var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.productPage != 'true' ? 'maps' : ''},[_c('div',{class:_vm.productPage == 'true'
        ? 'mapContainerProduct'
        : 'mapContainerHome',attrs:{"dir":"ltr","id":_vm.divId}})])}
var staticRenderFns = []

export { render, staticRenderFns }